export const DEFAULT_HIGHLIGHT_PROMPT = "As you read, highlight two sentences "
export const BECAUSE = 'because';
export const BUT = 'but';
export const SO = 'so';
export const READ_PASSAGE_STEP_NUMBER = 1
export const BECAUSE_PASSAGE_STEP_NUMBER = 2
export const BUT_PASSAGE_STEP_NUMBER = 3
export const SO_PASSAGE_STEP_NUMBER = 4

export const EVIDENCE = 'evidence';
export const CONNECT = 'connect';
export const DIAGNOSTIC = 'diagnostic';
export const GRAMMAR = 'grammar';
export const LESSONS = 'lessons';
export const PROOFREADER = 'proofreader';

export const CURRICULUM = 'curriculum';
export const PARTNERSHIPS = 'partnerships';
export const PRODUCT = 'product';
export const SUPPORT = 'support';
export const TRANSLATIONS = 'translations';
export const TEAMS = [CURRICULUM, PARTNERSHIPS, PRODUCT, SUPPORT];

export const ARCHIVED_FLAG = 'archived'
export const PRODUCTION_FLAG = 'production'
export const ALPHA_FLAG = 'alpha'
export const BETA_FLAG = 'beta'
export const GAMMA_FLAG = 'gamma'
export const PRIVATE_FLAG = 'private'

export const NOT_APPLICABLE = 'N/A'

export const STUDENT = 'student'
export const TEACHER = 'teacher'
export const INDIVIDUAL_CONTRIBUTOR = 'individual-contributor'
export const ADMIN = 'admin'

export const NOT_LISTED = 'not listed'
export const NO_SCHOOL_SELECTED = 'no school selected'

export const SKIPPED = 'Skipped'
export const PENDING = 'Pending'
export const APPROVED = 'Approved'
export const DENIED = 'Denied'

export const EVIDENCE_HANDBOOK_LINK = 'https://docsend.com/view/29vcfdqa5aupkmfp'

export const MAX_VIEW_WIDTH_FOR_MOBILE_NAVBAR = 1150

// Sentry
export const SENTRY_DSN = 'https://528794315c61463db7d5181ebc1d51b9@o95148.ingest.sentry.io/210579'

// Evidence teacher preview step consts
export const INTRODUCTION = 'introduction'
export const CHECKLIST = 'checklist'
export const READ_AND_HIGHLIGHT = 'read-and-highlight'

export const ALLOWED_ATTEMPTS = 5

export const INDETERMINATE = 'indeterminate'
export const ACTIVE = 'active'
export const INACTIVE = 'inactive'
export const DISABLED = 'disabled'
export const DEFAULT = 'default'
export const HOVER = 'hover'

export const EXTRA_EXTRA_SMALL_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/2xs`
export const EXTRA_SMALL_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/xs`
export const SMALL_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/s`
export const SMALL_MEDIUM_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/sm`
export const LARGE_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/l`
export const EXTRA_LARGE_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/xl`

// Connect feedback types
export const REVISE_UNMATCHED = 'revise-unmatched'
export const REVISE_MATCHED = 'revise-matched'
export const CORRECT_MATCHED = 'correct-matched'
export const OVERRIDE = 'override'
export const INCORRECT_CONTINUE = 'incorrect-continue'
export const CONTINUE = 'continue'
export const INSTRUCTIONS = 'instructions'
export const GET_QUESTION_INSTRUCTIONS = 'getQuestion-instructions'
export const DEFAULT_WITH_CUES = 'default-with-cues'
export const DEFAULT_FILL_IN_BLANK = 'default-fill-in-blank'
